import React, { Component } from 'react'
import { Product as ProductPb } from '../../rpc/admin/products_pb';
import { Picker, Category, CategoryDescriptor, Attribute } from '../../rpc/admin/categories_pb';
import TextAttribute from './text_attribute';
import { ProductContext } from './context';
import ColorAttribute from './color_attribute';

interface AttributesProps {
    values: Array<ProductPb.Variant.AttributeValuePair>;
    category?: Category;
    disabled?: boolean;
    onChange?: (value: Array<ProductPb.Variant.AttributeValuePair>) => void;
}

interface AttributesState {}

const COLUMN_COUNT = 3;

class Attributes extends Component<AttributesProps, AttributesState> {

    private handleAttributeChange = (value: ProductPb.Variant.AttributeValuePair) => {
        const attributes: Array<ProductPb.Variant.AttributeValuePair> = [];
        let found = false;
        this.props.values.forEach((attr) => {
            if (attr.getAttribute() === value.getAttribute()) {
                found = true;
                attributes.push(value);
            } else {
                attributes.push(attr);
            }
        });
        if (!found) {
            attributes.push(value);
        }
        if (this.props.onChange) {
            this.props.onChange(attributes);
        }
    }

    private descriptorForCategory = (descriptors: Array<CategoryDescriptor>): CategoryDescriptor => {
        for (let i = 0; i < descriptors.length; i++) {
            if (descriptors[i].getCategory() === this.props.category) {
                return descriptors[i];
            }
        }
        return new CategoryDescriptor();
    }

    private chunkAttributes(descriptor: CategoryDescriptor): Array<JSX.Element> {
        const values = this.props.values ? this.props.values : [];
        let pickers: Array<JSX.Element> = [];
        const columns: Array<JSX.Element> = [];
        const attributes: Array<Attribute> = [];

        descriptor.getAttributesList().forEach((attr) => {
            if (pickers.length === COLUMN_COUNT) {
                columns.push(
                    <div className="columns" key={'attribute-col-' + columns.length}>
                        {
                            pickers.map((picker) => {
                                return picker;
                            })
                        }
                    </div>
                );
                pickers = [];
            }

            var value = new ProductPb.Variant.AttributeValuePair();
            for (let i = 0; i < values.length; i++) {
                if (values[i].getAttribute() === attr.getAttribute()) {
                    value = values[i];
                    break;
                }
            }
            value.setAttribute(attr.getAttribute());
            value.setPicker(attr.getPicker());

            let found = false;
            attributes.forEach((a) => {
                if (a === attr.getAttribute()) {
                    found = true;
                }
            })
            if (!found) {
                attributes.push(attr.getAttribute());
                switch (attr.getPicker()) {
                    case Picker.COLOR:
                        if (!value.getColorPicker()) {
                            value.setColorPicker(new ProductPb.Variant.AttributeValuePair.ColorPicker());
                        }
                        pickers.push(
                            <div className="column" key={attr.getAttribute()}>
                                <ColorAttribute label={attr.getName()}
                                    value={value}
                                    disabled={this.props.disabled}
                                    onChange={this.handleAttributeChange} />
                            </div>
                        );
                        break;
                    default:
                        pickers.push(
                            <div className="column" key={attr.getAttribute()}>
                                <TextAttribute label={attr.getName()}
                                    value={value}
                                    disabled={this.props.disabled}
                                    onChange={this.handleAttributeChange} />
                            </div>
                        );
                }
            }
        });

        if (pickers.length !== 0 ) {
            while (pickers.length < COLUMN_COUNT) {
                pickers.push(
                    <div className="column" key={'attribute-col-' + columns.length + '-' + pickers.length}></div>
                );
            }
            columns.push(
                <div className="columns" key={'attribute-col-' + columns.length}>
                    {
                        pickers.map((picker) => {
                            return picker;
                        })
                    }
                </div>
            );
        }

        return columns;
    }

    render() {
        return (
            <ProductContext.Consumer>
                {ctx => (
                    <>
                        {
                            this.chunkAttributes(this.descriptorForCategory(ctx.categoryDescriptors || []))
                        }
                    </>
                )}
            </ProductContext.Consumer>
        );
    }
}

export default Attributes;
